import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import triggerAnalyticsEvent, { Analytics } from '../../../../helpers/analyticsMiddleware';
import { t } from '../../../../strings/i18n/i18n';
import DisputesImage from '../../../../ui/atoms/DisputesImage';
import { shallowEqual, useSelector } from 'react-redux';
import TransactionDescriptionBanner from '../../../../ui/molecules/TransactionDescriptionBanner';
import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth';
import { CancelQuestionnaireBody, CancelQuestionnaireContainer, CancelQuestionnaireContentContainer, CancelQuestionnaireHeader, CancelQuestionnaireImageContainer } from './subcomponents';
var CancelQuestionnaire = function () {
    var _a = useSelector(function (state) { return state; }, shallowEqual), assetsURL = _a.mfeConfig.assetsURL, merchantDesc = _a.transactionData.merchantDesc;
    var isLessThanTablet = useWindowSize().isLessThanTablet;
    var imageSize = isLessThanTablet ? 'xsmall' : 'small';
    useEffect(function () {
        triggerAnalyticsEvent({
            PageKind: Analytics.Dispute,
            PageFunction: Analytics.Billing,
            PageSubFunction: Analytics.Form,
            pageName: Analytics.CancelConfirmation
        });
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(TransactionDescriptionBanner, { description: merchantDesc }), _jsxs(CancelQuestionnaireContainer, { children: [_jsx(CancelQuestionnaireImageContainer, { children: _jsx(DisputesImage, { assetsHost: assetsURL, imageName: "WARNING", size: imageSize }) }), _jsxs(CancelQuestionnaireContentContainer, { children: [_jsx(CancelQuestionnaireHeader, { children: t('cancelQuestionnaire.title') }), _jsx(CancelQuestionnaireBody, { children: t('cancelQuestionnaire.description') })] })] })] }));
};
export default CancelQuestionnaire;
//# sourceMappingURL=index.js.map